import axios from 'axios';
import { loadAbort } from '../utilities';
import { UnifiedParams } from '@/interfaces/tables.interfaces';

const route = import.meta.env.VITE_API_URL + 'admin';

export const post = (data) => {
  const controller = loadAbort();
  return {
    call: () => axios.post(route, { ...data }, { signal: controller.signal }),
    controller,
  };
};

export const getAll = () => {
  const controller = loadAbort();
  return {
    call: () => axios.get(route, { signal: controller.signal }),
    controller,
  };
};

export const getById = (id: string) => {
  const controller = loadAbort();
  return {
    call: () => axios.get(`${route}/${id}`, { signal: controller.signal }),
    controller,
  };
};

export const remove = (id) => {
  const controller = loadAbort();
  return {
    call: () => axios.delete(`${route}/${id}`, { signal: controller.signal }),
    controller,
  };
};

export const put = (id, data) => {
  const controller = loadAbort();
  return {
    call: () => axios.put(`${route}/${id}`, { ...data }, { signal: controller.signal }),
    controller,
  };
};

export const getUnifiedAdmin = (params: UnifiedParams) => {
  const controller = loadAbort();

  return {
    call: () =>
      axios.post(`${route}/unified`, params, {
        signal: controller.signal,
      }),
    controller,
  };
};

export default {
  post,
  remove,
  put,
};
